import React from 'react';
import { Share2, MessageCircle, Linkedin } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Social Sharing Component
 * Allows users to share their quotes on social media
 */
const SocialShare = ({ quote, customerName, onShare }) => {
  const shareUrl = window.location.href;
  const quoteAmount = quote?.total || '0';
  const projectType = quote?.projectName || 'project';

  // Share text templates
  const shareText = `Just generated a $${quoteAmount} quote for ${projectType} in 90 seconds with QuoteSnapp! 🚀 Stop losing jobs to slow estimates. Try it free: ${shareUrl}`;
  
  const twitterText = `💼 Generated a $${quoteAmount} ${projectType} quote in 90 seconds with @QuoteSnapp!\n\n⚡ Win more jobs by being faster.\n\nTry it free:`;
  
  const linkedInText = `Just used QuoteSnapp to generate a professional $${quoteAmount} quote for ${projectType} in under 2 minutes. As a contractor, speed matters - clients who respond first win 73% of jobs. Highly recommend this tool for any contractor looking to close more deals faster.`;

  const handleShare = (platform) => {
    let url = '';
    
    switch(platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`;
        break;
      
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(twitterText)}&url=${encodeURIComponent(shareUrl)}`;
        break;
      
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
        break;
      
      default:
        return;
    }

    // Open in popup
    window.open(
      url,
      'share-dialog',
      'width=600,height=400,location=0,menubar=0,toolbar=0,status=0'
    );

    // Track share (optional callback)
    if (onShare) {
      onShare(platform);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-slate-600 font-medium">
        Share your success:
      </p>
      
      <div className="flex gap-2 flex-wrap">
        {/* Facebook Share */}
        <Button
          onClick={() => handleShare('facebook')}
          variant="outline"
          className="flex items-center gap-2 bg-[#1877f2] text-white hover:bg-[#0e62c7] border-[#1877f2]"
          size="sm"
        >
          <Share2 className="w-4 h-4" />
          Facebook
        </Button>

        {/* Twitter Share */}
        <Button
          onClick={() => handleShare('twitter')}
          variant="outline"
          className="flex items-center gap-2 bg-[#1da1f2] text-white hover:bg-[#0d8bd9] border-[#1da1f2]"
          size="sm"
        >
          <MessageCircle className="w-4 h-4" />
          Twitter
        </Button>

        {/* LinkedIn Share */}
        <Button
          onClick={() => handleShare('linkedin')}
          variant="outline"
          className="flex items-center gap-2 bg-[#0a66c2] text-white hover:bg-[#084d94] border-[#0a66c2]"
          size="sm"
        >
          <Linkedin className="w-4 h-4" />
          LinkedIn
        </Button>
      </div>

      <p className="text-xs text-slate-500">
        Help other contractors discover faster quotes! 🚀
      </p>
    </div>
  );
};

export default SocialShare;
